"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moneyfy = void 0;
const moneyfy = (currency, config) => val => {
  const value = val || 0;
  const decimals = config?.noDecimals ? 0 : undefined;
  const locales = config?.locales ?? "en-US";
  return value.toLocaleString(locales, {
    style: "currency",
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};
exports.moneyfy = moneyfy;